// Extrae el mensaje controlado que devuelve el API ante un error.
// Formatos que maneja el backend:
//   - Error de negocio:   { error: "mensaje", code: 409 }
//   - Validación (422):   { message: "Error de validación", errors: { campo: ["detalle"] } }
// Prioriza el detalle de validación, luego el error de negocio y por último
// un texto genérico.
export function extractApiError(err, fallback = "No se pudo realizar la acción.") {
  const data = err && err.response && err.response.data;
  if (!data) return fallback;

  if (data.errors) {
    const details = [];
    Object.keys(data.errors).forEach((key) => {
      const fieldErrors = data.errors[key];
      if (Array.isArray(fieldErrors)) {
        details.push(...fieldErrors);
      } else if (fieldErrors) {
        details.push(String(fieldErrors));
      }
    });
    if (details.length > 0) return details.join(" ");
  }

  return data.error || data.message || fallback;
}
